/**
 * CoreWeave brand colours, mirroring the `--cw-*` custom properties published
 * in the stylesheet on coreweave.com. Names follow theirs so the mapping stays
 * checkable against the source.
 *
 * Note that CoreWeave's accent is blue: their palette carries no yellow or
 * gold, which is why the blog's former gold treatments map onto CW_BLUE rather
 * than onto a warmer equivalent.
 */

/** `--cw-blue`, the primary accent and light-mode button fill. */
export const CW_BLUE = '#0541e9';

/** `--cw-blue-900`, the hover partner for CW_BLUE. */
export const CW_BLUE_HOVER = '#2374ff';

/** `--cw-blue-500`, the palest blue, for tinted panels on light backgrounds. */
export const CW_BLUE_TINT = '#ecf4ff';

/** `--cw-blue-1300`, the darkest blue, the tinted panel's dark-mode partner. */
export const CW_BLUE_DEEP = '#001581';

/** `--cw-light-gray`, for page bands that should read as a distinct surface. */
export const CW_LIGHT_GRAY = '#f4f5f7';

/** `--cw-neutral-1300`, the darkest neutral, used for text on light surfaces. */
export const CW_INK = '#232528';
